import { useState } from 'react'
import PropTypes from 'prop-types'

function Accordion({ title, items }) {
  // Local state
  const [activeDropdown, setActiveDropdown] = useState(null)

  if (!items?.length) return false
  return (
    <div>
      {title && (
        <h3 className="mb-2 text-lg font-semibold text-gray-800">{title}</h3>
      )}
      {items.map(({ title, content }, i) => (
        <button
          key={`item-${i}`}
          className="block w-full py-1 text-left focus:outline-none"
          onClick={() => setActiveDropdown(activeDropdown == i ? null : i)}
        >
          <div className="flex items-center space-x-4 text-gray-800">
            <div
              className={`${activeDropdown == i ? '' : '-rotate-90'}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            <div>{title}</div>
          </div>
          <div
            className={`py-4 pl-6 ${
              activeDropdown == i ? 'ml-2 block border-l' : 'hidden'
            }`}
          >
            {content}
          </div>
        </button>
      ))}
    </div>
  )
}

Accordion.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
}

export default Accordion
